import { render, staticRenderFns } from "./ResearchInitiativeChange.vue?vue&type=template&id=1eda0202&scoped=true"
import script from "./ResearchInitiativeChange.vue?vue&type=script&lang=js"
export * from "./ResearchInitiativeChange.vue?vue&type=script&lang=js"
import style0 from "./ResearchInitiativeChange.vue?vue&type=style&index=0&id=1eda0202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eda0202",
  null
  
)

export default component.exports